import { render, staticRenderFns } from "./frm_create.vue?vue&type=template&id=4e90ae66&scoped=true&"
import script from "./frm_create.vue?vue&type=script&lang=js&"
export * from "./frm_create.vue?vue&type=script&lang=js&"
import style0 from "./frm_create.vue?vue&type=style&index=0&id=4e90ae66&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e90ae66",
  null
  
)

export default component.exports